
export default {
  name: "FooterContact",
};
